import { useMutation } from '@tanstack/react-query';
import { useToast } from '@/hooks/use-toast';
import { apiClient, unwrap } from '@/lib/api-client';
import { createCrudHooks } from './create-crud-hooks';

export const {
  keys: userKeys,
  useList: useUsers,
  useDetail: useUser,
  useCreate: useCreateUser,
  useUpdate: useUpdateUser,
  useDelete: useDeleteUser,
} = createCrudHooks(apiClient.users, 'users');

/** Reset de senha (admin) — gera e retorna uma senha temporária, mostrada uma única vez. */
export function useResetUserPassword() {
  const toast = useToast();

  return useMutation({
    mutationFn: async (userId: string) => {
      const res = await (apiClient.users({ id: userId }) as any)['reset-password'].post();
      return unwrap(res.data) as { password: string };
    },
    onError: (e: any) => {
      toast.error(e.message ?? 'Não foi possível resetar a senha.');
    },
  });
}
